<template>
    <div>
        <!-- Alerts -->
        <b-alert variant="success" :show="showAlert_success" @dismissed="showAlert_success = false">
            {{ alert_success_message }}
        </b-alert>
        <b-alert variant="danger" :show="showAlert_error" @dismissed="showAlert_error = false">
            {{ alert_error_message }}
        </b-alert>

        <b-container fluid>
            <h3 class="mt-3 mb-4">Quick Action Panel</h3>

            <b-row>
                <b-col v-for="func in functions" :key="func.key" cols="12" md="6" lg="4" class="mb-4">
                    <b-card class="h-100">
                        <h5>{{ func.label }}</h5>
                        <p class="text-muted small">{{ func.description }}</p>
                        <b-button :variant="func.variant" @click="openModal(func.key)">
                            {{ func.buttonText }}
                        </b-button>
                    </b-card>
                </b-col>
            </b-row>

            <!-- Reusable Modal -->
            <b-modal id="function-modal" ref="functionModal" title="Function Input" @ok="submitFunction"
                ok-title="Submit" cancel-title="Cancel">
                <div v-if="currentFunction === 'functionA'">
                    <b-form-group label="Input for Function A">
                        <b-form-input v-model="form.inputA" />
                    </b-form-group>
                </div>
                <div v-else-if="currentFunction === 'functionB'">
                    <b-form-group label="Parameter for Function B">
                        <b-form-input v-model="form.inputB" />
                    </b-form-group>
                </div>
                <div v-else-if="currentFunction === 'functionC'">
                    <b-form-group label="Details for Function C">
                        <b-form-textarea v-model="form.inputC" />
                    </b-form-group>
                </div>
                <div v-else-if="currentFunction === 'packingListXls'">
                    <b-form-group label="Tracking Number">
                        <b-form-input v-model="form.trackingNumber" />
                    </b-form-group>
                </div>

            </b-modal>
        </b-container>
    </div>
</template>


<script>
export default {
    name: "QuickActionPage",
    inject: ["API_HOST"],
    data() {
        return {
            showAlert_success: false,
            alert_success_message: "",
            showAlert_error: false,
            alert_error_message: "",
            currentFunction: "",
            form: {
                inputA: "",
                inputB: "",
                inputC: "",
                trackingNumber: ""
            },
            functions: [
                {
                    key: "packingListXls",
                    label: "Download Packing List",
                    description: "Downloads an XLS file containing packing list content based on tracking number.",
                    buttonText: "Download XLS",
                    variant: "info"
                },
                {
                    key: "functionB",
                    label: "Sync Inventory",
                    description: "Force-syncs stock level from warehouse to system records.",
                    buttonText: "Run Sync",
                    variant: "success"
                },
                {
                    key: "functionC",
                    label: "Purge Temp Files",
                    description: "Deletes temporary files generated from past automation runs.",
                    buttonText: "Run Cleanup",
                    variant: "warning"
                }
            ]
        };
    },
    methods: {
        openModal(funcKey) {
            this.currentFunction = funcKey;
            this.resetForm();
            this.$refs.functionModal.show();
        },
        resetForm() {
            this.form = {
                inputA: "",
                inputB: "",
                inputC: "",
                trackingNumber: ""
            };
        },
        async submitFunction() {
            try {
                if (this.currentFunction === "packingListXls") {
                    const tracking = this.form.trackingNumber.trim();
                    if (!tracking) throw new Error("Tracking number is required.");
                    const url = `https://sys.gols.com.hk/api/packing_list_as_xls.php?tracking_number=${encodeURIComponent(tracking)}`;
                    window.open(url, "_blank");
                    this.alert_success_message = `Packing list requested for ${tracking}`;
                    this.showAlert_success = true;
                    return;
                }

                // other functions...
            } catch (error) {
                this.alert_error_message = error.message || `Failed to execute ${this.currentFunction}`;
                this.showAlert_error = true;
            }
        }
    }
};

</script>

<style scoped>
.card-title {
    font-size: 1.1rem;
    font-weight: bold;
}

.card p {
    min-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/UtilityFunctions.vue